import GenericStore from '../../classes/generic-store';

class DeleteProfileImageModalClass extends GenericStore {
  load(data) {
    return this.setState(data);
  }

  cancel() {
    this.clearState();
  }
}

export const DeleteProfileImageModalStore = new DeleteProfileImageModalClass();
